import { useState } from "react";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { SiGoogle } from "react-icons/si";
import { AuthModal } from "@/components/auth-modal";

interface AuthButtonProps {
  className?: string;
}

export function AuthButton({ className = '' }: AuthButtonProps) {
  const { user, signOutUser } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  
  return (
    <>
      {user ? (
        <Button variant="outline" onClick={signOutUser} className={`gap-2 ${className}`}>
          {user.photoURL ? (
            <img 
              src={user.photoURL} 
              alt="" 
              className="w-5 h-5 rounded-full" 
              onError={(e) => e.currentTarget.style.display = 'none'}
            />
          ) : (
            <div className="w-5 h-5 rounded-full bg-pink-100 flex items-center justify-center text-xs text-pink-500">
              {user.displayName ? user.displayName.charAt(0).toUpperCase() : 'U'}
            </div>
          )}
          Sign Out
        </Button>
      ) : (
        <Button onClick={() => setShowAuthModal(true)} className={`gap-2 ${className}`}>
          Sign in
        </Button>
      )}

      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)} 
      />
    </>
  );
}
